import {
  Box,
  Text,
  Columns,
  Column,
  IconVideo,
  Spread,
} from 'braid-design-system';

import TrackingLink from 'src/App/Components/TrackingLink/TrackingLink';
import { analyticsEvents } from 'src/constants/analytics';
import { TRACKING_DASHBOARD_ARTICLE } from 'src/constants/tracking';

import * as styles from './HiringAdvice.css';

interface Props {
  imageUrl: string;
  imageTitle: string;
  articleTitle: string;
  articleUrl: string;
  timeToRead: number;
}

interface ImageProps {
  imageUrl: string;
  imageTitle: string;
}

const isBrightcoveVideo = (imageUrl: string) =>
  imageUrl.startsWith('https://players.brightcove.net/');

const HiringAdviceImage = ({ imageUrl, imageTitle }: ImageProps) => {
  if (isBrightcoveVideo(imageUrl)) {
    return (
      <Box
        className={styles.thumbnail}
        display="flex"
        alignItems="center"
        justifyContent="center"
        borderRadius="standard"
        background="positiveLight"
      >
        <Box
          borderRadius="full"
          padding="xsmall"
          background="customDark"
          className={styles.playBtn}
        >
          <IconVideo size="large" />
        </Box>
      </Box>
    );
  }

  return (
    <Box
      className={styles.thumbnail}
      component="img"
      src={imageUrl}
      alt={imageTitle}
      borderRadius="standard"
    />
  );
};

const displayTimeToRead = (imageUrl: string, timeToRead: number) => {
  if (isBrightcoveVideo(imageUrl)) {
    return (
      <Text size="small" tone="secondary">
        {timeToRead} min watch
      </Text>
    );
  }
  return (
    <Text size="small" tone="secondary">
      {timeToRead} min read
    </Text>
  );
};

const HiringAdviceItem = ({
  imageUrl,
  imageTitle,
  articleTitle,
  articleUrl,
  timeToRead,
}: Props) => (
  <TrackingLink
    href={articleUrl}
    target="_blank"
    rel="noopener"
    trackingEventName={analyticsEvents.TRACK_CONTENT_ELEMENT}
    trackingActionOrigin={TRACKING_DASHBOARD_ARTICLE}
    trackingData={{
      elementAction: 'article link clicked',
      elementDesign: 'image',
      elementText: articleTitle,
    }}
  >
    <Box cursor="pointer" overflow="hidden" height="full">
      <Box
        borderRadius="large"
        paddingX="small"
        paddingY="medium"
        boxShadow="borderNeutralLight"
        height="full"
      >
        <Columns space="xsmall">
          <Column>
            <Spread space="medium" direction="vertical">
              <Text component="h4" size="small" maxLines={2} weight="strong">
                {articleTitle}
              </Text>
              {displayTimeToRead(imageUrl, timeToRead)}
            </Spread>
          </Column>
          <Column width="content">
            <HiringAdviceImage imageUrl={imageUrl} imageTitle={imageTitle} />
          </Column>
        </Columns>
      </Box>
    </Box>
  </TrackingLink>
);

export default HiringAdviceItem;
